import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ProgramPage from "./pages/ProgramPage";
import EvidenceLibrary from "./pages/EvidenceLibrary";
import { programs } from "./mock";
import { trackPageView } from "./lib/tracking";

function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, [location.pathname, location.hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageViewTracker />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/anxiety-depression" element={<ProgramPage data={programs.anxiety} />} />
          <Route path="/diabetes" element={<ProgramPage data={programs.diabetes} />} />
          <Route path="/sleep-health" element={<ProgramPage data={programs.sleep} />} />
          <Route path="/recurring-headaches" element={<ProgramPage data={programs.headaches} />} />
          <Route path="/digestion-gut-health" element={<ProgramPage data={programs.gut} />} />
          <Route path="/cancer-care" element={<ProgramPage data={programs.cancer} />} />
          <Route path="/mobility-arthritis" element={<ProgramPage data={programs.arthritis} />} />
          <Route path="/cholesterol-triglycerides" element={<ProgramPage data={programs.cholesterol} />} />
          <Route path="/womens-health" element={<ProgramPage data={programs.womens} />} />
          <Route path="/evidence-library" element={<EvidenceLibrary />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
